import { motion, AnimatePresence, type Transition } from "motion/react";
import { type PropsWithChildren, useState } from "react";

type CollapseProps = PropsWithChildren<{
  isOpen: boolean;
  skipInitial?: boolean;
  className?: string;
  transition?: Transition;
}>;

const DEFAULT_TRANSITION: Transition = { duration: 0.3 };

export const Collapse = ({
  isOpen,
  children,
  skipInitial = false,
  className = "",
  transition = DEFAULT_TRANSITION,
}: CollapseProps) => {
  const [height, setHeight] = useState(isOpen ? "auto" : 0);

  return (
    <AnimatePresence initial={!skipInitial}>
      {isOpen && (
        <motion.div
          style={{ overflow: "hidden", height }}
          initial={{ height: 0 }}
          animate={{ height: "auto" }}
          exit={{ height: 0 }}
          transition={transition}
          onAnimationComplete={() => setHeight(isOpen ? "auto" : 0)}
          className={className}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
